



































































import { RouterNames } from "@/router/routernames";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import productoModule from "@/store/modules/producto-module";
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import ProcesoReparacion from "../procesos/proceso_reparacion.vue";
import ProcesoVenta from "../procesos/proceso_venta.vue";
import ProcesoMerma from "../procesos/proceso_merma.vue";
import ProcesoRecepcionar from "../procesos/proceso_recepcionar.vue";
import ProcesoEnvio from "../procesos/proceso_envio.vue";
import ProcesoReservado from "../procesos/proceso_reservado.vue";
import ProcesoPendientePago from "../procesos/proceso_pendiente_pago.vue";
import ProcesoDevolucion from "../procesos/proceso_devolucion.vue";
import { ProcessoNums, getTexto, getNumero } from "../procesos/ProcessoNums";
import { producto } from "@/shared/dtos/producto";
import { BaseDto } from "@/shared/dtos/base-dto";
@Component({
  components: {
    ProcesoVenta,
    ProcesoReparacion,
    ProcesoMerma,
    ProcesoRecepcionar,
    ProcesoEnvio,
    ProcesoReservado,
    ProcesoPendientePago,
    ProcesoDevolucion,
  },
})
export default class ProcesosProducto extends Vue {
  public producto: producto = new producto();
  public precio_venta = 0;
  public proceso_venta_show = false;
  public proceso_reparacion_show = false;
  public proceso_merma_show = false;
  public proceso_recepcionar_show = false;
  public proceso_enviar_show = false;
  public proceso_reservar_show = false;
  public proceso_pdt_pago_show = false;
  public proceso_devolucion_show = false;
  @PropSync("id", { default: -1 }) id_producto!: number;

  public cards = [
    {
      text: "VER PRODUCTO",
      icon: "fas fa-eye",
      descripcion: "Ver la ficha del producto",
    },
    {
      text: "VENDER",
      icon: "fas fa-shopping-cart",
      descripcion: "Vender el producto y sale de almacén",
    },
    {
      text: "ENVIAR A REPARACIÓN",
      icon: "fas fa-tools",
      descripcion: "Sale del almacén a reparar",
    },
    {
      text: "MERMA / ROTO",
      icon: "fas fa-trash",
      descripcion: "Sale del almacén se tira, no funciona",
    },
    {
      text: "RECEPCIONAR PRODUCTO",
      icon: "fas fa-box",
      descripcion: "Entra el producto al almacén",
    },
    {
      text: "ENVIAR",
      icon: "fas fa-paper-plane",
      descripcion: "Sale del almacén aún no tienes el dinero",
    },
    {
      text: "RESERVAR",
      icon: "far fa-bookmark",
      descripcion: "No sale del almacén, solo reservado",
    },
    {
      text: "PDT PAGO",
      icon: "fas fa-piggy-bank",
      descripcion: "Sale del almacén aún no tienes el dinero",
    },
    {
      text: "Devolución",
      icon: "fas fa-undo",
      descripcion: "Entra el producto al almacén, después de una venta",
    },
  ];

  async created() {
    await productoModule.getproductos();

    this.producto = productoModule.productos.find(
      (x) => x.id == this.id_producto
    ) || new producto();
  }

  onCardClick(action: any, index: any) {
    if (!this.producto) {
      alert("Producto no encontrado.");
    }
    switch (index) {
      case 0:
        this.$router.push({
          name: RouterNames.fichaproducto,
          params: { id: this.producto.id },
        });
        break;
      case 1:
        this.proceso_venta_show = true;
        break;
      case 2:
        this.proceso_reparacion_show = true;
        break;
      case 3:
        this.proceso_merma_show = true;
        break;
      case 4:
        this.proceso_recepcionar_show = true;
        break;
      case 5:
        this.proceso_enviar_show = true;
        break;
      case 6:
        this.proceso_reservar_show = true;
        break;
      case 7:
        this.proceso_pdt_pago_show = true;
        break;
      case 8:
        this.proceso_devolucion_show = true;
        break;
      default:
        break;
    }
  }

  async visible(action: any, index: any) {
    var aux_producto = new producto(this.producto);
    if (typeof aux_producto.estado === "string") {
      try {
        aux_producto.estado = getNumero(aux_producto.estado);
      } catch (error) {
        await productoModule.getproductos();
        this.producto = productoModule.productos.find(
          (x) => x.id == this.id_producto
        ) || new producto();
        aux_producto = new producto(this.producto);
        if (typeof aux_producto.estado === "string") {
          aux_producto.estado = getNumero(aux_producto.estado);
        }
      }
    }
    if (!aux_producto) {
      return false;
    }
    switch (index) {
      case 0: //Ver producto
        return true;
        break;
      case 1: //Vender
        return (
          aux_producto.estado === ProcessoNums.Disponible ||
          aux_producto.estado === ProcessoNums.PendientePago ||
          aux_producto.estado === ProcessoNums.Reservado ||
          aux_producto.estado === ProcessoNums.Envio
        );
        break;
      case 2: //Enviar a reparación
        return aux_producto.estado === ProcessoNums.Disponible;
        break;
      case 3: //Merma / Roto
        return aux_producto.estado === ProcessoNums.Disponible;
        break;
      case 4: //Recepcionar producto
        return (
          aux_producto.estado === ProcessoNums.Envio ||
          aux_producto.estado === ProcessoNums.PendientePago ||
          aux_producto.estado === ProcessoNums.Reservado ||
          aux_producto.estado === ProcessoNums.Reparacion ||
          aux_producto.estado === ProcessoNums.MermaRoto
        );
        break;
      case 5: //Enviar
        return aux_producto.estado === ProcessoNums.Disponible;
        break;
      case 6: //Reservar
        return aux_producto.estado === ProcessoNums.Disponible;
        break;
      case 7: //Pdt Pago
        return aux_producto.estado === ProcessoNums.Disponible;
        break;
      case 8: //Devolución
        return (
          aux_producto.estado === ProcessoNums.Envio ||
          aux_producto.estado === ProcessoNums.PendientePago ||
          aux_producto.estado === ProcessoNums.Reservado ||
          aux_producto.estado === ProcessoNums.Reparacion ||
          aux_producto.estado === ProcessoNums.VendidoEfectivo ||
          aux_producto.estado === ProcessoNums.VendidoTarjeta
        );
        break;
      default:
        return false;
        break;
    }
  }

  get mostrarCamposCoste() {
    return ocultarcamposModule.mostrar_campos_coste;
  }
}
